// src/components/terms-and-conditions/terms-and-conditions.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    text\n    action {\n      resource {\n        value\n      }\n      accessibility\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment CouponsTextFragment on CouponsText {\n    combinedTexts {\n      text\n      link {\n        ...EGDSInlineLinkFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment CouponDetailsContainerFragment on CouponDetailsContainer {\n    title\n    type\n    content {\n      ...CouponsTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  query TermsAndConditionsQuery($context: ContextInput!, $couponInstanceId: String!, $rewardId: String!) {\n    couponsTermsAndConditions(context: $context, couponInstanceId: $couponInstanceId, rewardId: $rewardId) {\n      ... on TermsAndConditionsContent {\n        title\n        sections {\n          ...CouponDetailsContainerFragment\n        }\n        errorMessage\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React4 from "react";
import { gql as gql4, useQuery } from "@apollo/client";
import { UitkSpacing } from "@egds/react-core/spacing";
import { UitkHeading, UitkText as UitkText2 } from "@egds/react-core/text";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/terms-and-conditions/__private/__fragments/coupon-details-container.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkList, UitkListItem } from "@egds/react-core/list";
import { UitkParagraph, UitkText } from "@egds/react-core/text";
// src/components/terms-and-conditions/__private/__fragments/coupons-text.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
// src/components/terms-and-conditions/__private/__fragments/egds-inline-link.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkLink } from "@egds/react-core/link";
var fragment = gql(_templateObject());
var EGDSInlineLink = function(param) {
    var data = param.data;
    var _data_action_accessibility;
    return /* @__PURE__ */ React.createElement(UitkLink, {
        inline: true
    }, /* @__PURE__ */ React.createElement("a", {
        "aria-label": (_data_action_accessibility = data.action.accessibility) !== null && _data_action_accessibility !== void 0 ? _data_action_accessibility : void 0,
        href: data.action.resource.value,
        target: "_blank",
        rel: "noreferrer"
    }, data.text));
};
EGDSInlineLink.fragment = fragment;
EGDSInlineLink.displayName = "EGDSInlineLink";
// src/components/terms-and-conditions/__private/__fragments/coupons-text.tsx
var fragment2 = gql2(_templateObject1(), EGDSInlineLink.fragment);
var CouponsText = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, data.combinedTexts.map(function(value, index) {
        return /* @__PURE__ */ React2.createElement(React2.Fragment, null, value.text, value.link && /* @__PURE__ */ React2.createElement(EGDSInlineLink, {
            data: value.link,
            key: index
        }));
    }));
};
CouponsText.fragment = fragment2;
CouponsText.displayName = "CouponsText";
// src/components/terms-and-conditions/__private/__fragments/coupon-details-container.tsx
var fragment3 = gql3(_templateObject2(), CouponsText.fragment);
var CouponDetailsContainer = function(param) {
    var data = param.data;
    var title = data.title, type = data.type, content = data.content;
    if (type === "PARAGRAPH" /* PARAGRAPH */ ) {
        return /* @__PURE__ */ React3.createElement(UitkParagraph, null, /* @__PURE__ */ React3.createElement(UitkText, {
            weight: "bold",
            inline: true
        }, title), content.map(function(value, index) {
            return /* @__PURE__ */ React3.createElement(CouponsText, {
                data: value,
                key: index
            });
        }));
    }
    var listType = type === "ORDERED_LIST" /* ORDERED_LIST */  ? "ordered" : "unordered";
    return /* @__PURE__ */ React3.createElement(UitkParagraph, null, /* @__PURE__ */ React3.createElement(UitkText, {
        weight: "bold",
        inline: true
    }, title), /* @__PURE__ */ React3.createElement(UitkList, {
        type: listType,
        spacing: true
    }, content.map(function(value, index) {
        return /* @__PURE__ */ React3.createElement(UitkListItem, {
            key: index
        }, /* @__PURE__ */ React3.createElement(CouponsText, {
            data: value,
            key: "coupon-text-".concat(index)
        }));
    })));
};
CouponDetailsContainer.fragment = fragment3;
CouponDetailsContainer.displayName = "CouponDetailsContainer";
// src/components/terms-and-conditions/terms-and-conditions.tsx
var __Query = gql4(_templateObject3(), CouponDetailsContainer.fragment);
var TermsAndConditions = function(props) {
    var _data_couponsTermsAndConditions;
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || !data.couponsTermsAndConditions) {
        return null;
    }
    var _data_couponsTermsAndConditions1 = data.couponsTermsAndConditions, title = _data_couponsTermsAndConditions1.title, sections = _data_couponsTermsAndConditions1.sections, errorMessage = _data_couponsTermsAndConditions1.errorMessage;
    if (data.couponsTermsAndConditions == null || ((_data_couponsTermsAndConditions = data.couponsTermsAndConditions) === null || _data_couponsTermsAndConditions === void 0 ? void 0 : _data_couponsTermsAndConditions.errorMessage) !== null) {
        return /* @__PURE__ */ React4.createElement(UitkText2, {
            align: "center",
            spacing: "four",
            size: 400
        }, errorMessage);
    }
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(UitkSpacing, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React4.createElement(UitkHeading, {
        tag: "h3",
        size: 3
    }, title)), sections.map(function(value, index) {
        return /* @__PURE__ */ React4.createElement(CouponDetailsContainer, {
            data: value,
            key: index
        });
    }));
};
TermsAndConditions.displayName = "sharedui-TermsAndConditions";
export { TermsAndConditions };
//# sourceMappingURL=index.js.map